(() => {
  const productBox = document.getElementById("EcomManualProductBox");
  const variantId = productBox.dataset.variantId;
  const button = document.getElementById("EcomManualCartAdd");

  if (!productBox || !button) return;

  let selectedItems = [
    {
      id: variantId,
      quantity: 1,
    },
  ];

  function bindKachingWidget(kachingBlock) {
    if (!kachingBlock || kachingBlock.dataset.kachingBound === "true") return;

    kachingBlock.dataset.kachingBound = "true";

    kachingBlock.addEventListener("variants-changed", (event) => {
      const variantIdQuantities = event.detail?.variantIdQuantities || [];

      if (!variantIdQuantities.length) return;

      selectedItems = variantIdQuantities.map((item) => ({
        id: item.variantId,
        quantity: item.quantity,
      }));

      // console.log("Kaching selectedItems:", selectedItems);
    });
  }

  function findAndBindKaching() {
    const kachingBlock = productBox.querySelector("kaching-bundles-block");
    if (kachingBlock) {
      bindKachingWidget(kachingBlock);
      return true;
    }
    return false;
  }

  findAndBindKaching();

  const observer = new MutationObserver(() => {
    if (findAndBindKaching()) {
      observer.disconnect();
    }
  });

  observer.observe(productBox, {
    childList: true,
    subtree: true,
  });

  button.addEventListener(
    "click",
    async (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation?.();

      button.disabled = true;
      button.textContent = "Adding...";

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            items: selectedItems,
          }),
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.description || "Failed to add to cart");
        }

        button.textContent = "Added";
      } catch (error) {
        console.error(error);
        button.textContent = "Error";
      } finally {
        setTimeout(() => {
          button.disabled = false;
          button.textContent = "Add to cart";
        }, 1200);
      }
    },
    true,
  );
})();
